/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Notify_Events_RequiredInputs */

const en_fw_notify_events_required = /** @type {(inputs: Fw_Notify_Events_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick at least one event.`)
};

const id_fw_notify_events_required = /** @type {(inputs: Fw_Notify_Events_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih minimal satu kejadian.`)
};

/**
* | output |
* | --- |
* | "Pick at least one event." |
*
* @param {Fw_Notify_Events_RequiredInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_notify_events_required = /** @type {((inputs?: Fw_Notify_Events_RequiredInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Notify_Events_RequiredInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_notify_events_required(inputs)
	return en_fw_notify_events_required(inputs)
});